export { default as CubeTransparentOutlineIcon } from './CubeTransparentOutlineIcon';
